import {
  Flex, Grid, Radio, RadioProps,
} from "@mantine/core";
import useStyles from "./radioSelect.styles"

interface ExtendedRadioProps extends RadioProps {
  image?: string;
  active?: boolean;
  badgeValue?: string;
}

const RadioSelect = (props: ExtendedRadioProps) => {
  const { classes } = useStyles()
  const {
    value, label, description, image, active, badgeValue,
  } = props
  const isImagePresent = image !== undefined

  return (
    <Radio
      value={value}
      classNames={{
        body: `${classes.body} ${active ? classes.bodyActive : ""}`,
      }}
      label={(
        <Grid pl={8}>
          <Grid.Col pt={0} span={isImagePresent ? 9 : 12}>
            <Flex justify="space-between">
              <p className="heading_2xs_semibold">{label}</p>
              {badgeValue
              && (
              <span className={classes.badge}>
                {badgeValue}
              </span>
              )}
            </Flex>
            <p className="content_sm_regular">{description}</p>
          </Grid.Col>
          {isImagePresent && (
          <Grid.Col py={0} span={3} className={classes.imageWrapper}>
            <img className={classes.image} src={image} alt="Radio Select" />
          </Grid.Col>
          )}
        </Grid>
        )}
    />
  )
}

export default RadioSelect
